module.exports = __webpack_public_path__ + "img/f14f5bd.png";